

































































































































import '../styles/agent-resources.css'
import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import ResourceRow from '../components/ResourceRow.vue'
import ResourceDirectoryTile from '../components/ResourceDirectoryTile.vue'
import RemoveItemModal from '../components/general/RemoveItemModal.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilFileAdd, cilQueueRemove } from '@coreui/icons-pro'
import AddAgentResourceModal from '../components/AddAgentResourceModal.vue'
import Breadcrumbs from '../components/general/Breadcrumbs.vue'
import { mapState } from 'vuex'

interface IFavorite {
  id: number
  username: string
  agentResourceId: number
}

interface IAgentResource {
  id: number
  name: string
  description: string
  favorite: boolean
  favoriteId: number | undefined
  imageUrl: string
  resourceLink: string
  isDirectory: boolean
  parentId: number
  numberOfChildren: number
  searchPath: string
  searchIdPath: string
  lastUpdatedDate: Date
}

interface IModel {
  loading: boolean
  numColumns: number
  showAddModal: boolean
  showDeleteModal: boolean
  showResetModal: boolean
  deleteItem: IAgentResource | undefined
  searchText: string
  agentResources: IAgentResource[]
  onSearchId: number | undefined
  agentresourceAddIcon: any
  agentresourceResetIcon: any[]
  favorites: IFavorite[]
  parentId: number | undefined
  routes: any[]
  updateType: string
  editItem: IAgentResource | undefined
}

export default Vue.extend({
  components: {
    ScreenTile,
    ResourceRow,
    CIcon,
    AddAgentResourceModal,
    ResourceDirectoryTile,
    Breadcrumbs,
    RemoveItemModal,
  },
  data: function (): IModel {
    return {
      loading: true,
      showAddModal: false,
      showDeleteModal: false,
      showResetModal: false,
      deleteItem: undefined,
      searchText: '',
      numColumns: 3,
      agentResources: [] as IAgentResource[],
      onSearchId: undefined as number | undefined,
      favorites: [] as IFavorite[],
      agentresourceAddIcon: cilFileAdd,
      agentresourceResetIcon: cilQueueRemove,
      parentId: undefined as number | undefined,
      routes: [{ id: undefined, name: 'Agent Resources' }] as {
        id: number | undefined
        name: string
      }[],
      updateType: 'add',
      editItem: undefined as IAgentResource | undefined,
    }
  },
  mounted: async function () {
    if (this.$attrs.directoryId) {
      this.parentId = parseInt(this.$attrs.directoryId)
    }
    await this.loadResources()
    this.favorites = await (
      await fetch(
        '/api/favorites?' + new URLSearchParams({ agentResourcesOnly: 'true' })
      )
    ).json()
    this.loading = false
  },
  computed: {
    filteredAgentResources(): IAgentResource[] {
      if (this.searchText) {
        return this.agentResources.filter((x) =>
          x.name?.toLowerCase().includes(this.searchText?.toLowerCase())
        )
      }
      return this.agentResources
    },
    filteredSortedAgentResources(): IAgentResource[] {
      return this.filteredAgentResources.slice().sort((a, b) => {
        if (a.isDirectory && a.name === 'Portfolio') {
          return -1
        }
        if (
          a.isDirectory &&
          a.name === 'Legacy Portfolio' &&
          b.isDirectory &&
          b.name !== 'Portfolio'
        ) {
          return -1
        }
        if (
          a.isDirectory &&
          a.name === 'Legacy NAE' &&
          b.isDirectory &&
          !b.name.includes('Portfolio')
        ) {
          return -1
        }
        if (a.isDirectory && !b.isDirectory) {
          return -1
        } else if (!a.isDirectory && b.isDirectory) {
          return 1
        } else {
          return a.name.localeCompare(b.name)
        }
      })
    },

    ...mapState(['user']),
  },
  methods: {
    getFavorite: function (agentResourceId: number) {
      return this.favorites.find((x) => x.agentResourceId === agentResourceId)
    },
    getFavoriteId: function (agentResourceId: number) {
      return this.getFavorite(agentResourceId)?.id
    },

    resetResources: async function () {
      this.showResetModal = true
    },

    resetResourcesOnServer: async function () {
      this.loading = true
      this.showResetModal = false
      await fetch(`/api/agentResources/reset`, {
        method: 'POST',
      })
      this.agentResources = []
      this.loading = false
    },
    addResource: async function (id: number) {
      this.updateType = 'add'
      this.showAddModal = true
    },

    editResource: async function (id: number) {
      this.updateType = 'edit'
      this.showAddModal = true
      this.editItem = this.agentResources.find((x) => x.id === id)
    },

    resourceAdded: async function (item: IAgentResource) {
      this.loading = true
      this.showAddModal = false

      await this.loadResources()

      this.loading = false
    },
    recurseUpTo: async function (id: number) {
      this.loading = true
      const indexOfRoute = this.routes.findIndex((x) => x.id === id)
      this.routes = this.routes.slice(0, indexOfRoute + 1)
      this.parentId = this.routes[this.routes.length - 1]?.id
      await this.loadResources()

      this.loading = false
    },
    descendIntoDirectory: async function (id: number) {
      this.loading = true
      const agentResource = this.agentResources.find((x) => x.id === id)
      if (agentResource && agentResource.parentId != this.parentId) {
        const idArr = agentResource.searchIdPath.split(' / ')
        const pathArr = agentResource.searchPath.split(' / ')
        for (let i = 0; i < idArr.length; i++) {
          this.routes.push({
            id: idArr[i],
            name: pathArr[i],
          })
        }
      } else {
        this.routes.push({
          id,
          name: this.agentResources.find((x) => x.id === id)?.name ?? '',
        })
      }
      this.parentId = id
      this.$router.push({
        name: 'Agent Resources',
        params: { directoryId: id },
      })
      await this.loadResources()

      this.loading = false
    },
    openDocument: async (document: IAgentResource) => {
      // TODO: Show a toast or some other message when errors happen
      try {
        const canOpenResource = await fetch(`${document?.resourceLink}`)

        if (canOpenResource.ok) {
          window.open(document?.resourceLink)
        } else {
          // console.log('Was unable to open resource' + document?.resourceLink)
        }
      } catch {
        // console.log('Was unable to open resource' + document?.resourceLink)
      }
    },
    deleteResource: async function (id: number) {
      this.deleteItem = this.agentResources.find((x) => x.id === id)
      this.showDeleteModal = true
    },

    deleteItemOnServer: async function () {
      this.loading = true
      this.showDeleteModal = false

      if (this.deleteItem) {
        await fetch(`/api/agentresources/${this.deleteItem!.id}`, {
          method: 'DELETE',
        })
        if (this.searchText) {
          await this.loadResources()
        } else {
          this.agentResources = this.agentResources.filter(
            (x) => x.id !== this.deleteItem!.id
          )
        }
      }
      this.deleteItem = undefined
      this.loading = false
    },
    toggleFavorite: async function (params: {
      favoriteId?: number
      id?: number
    }) {
      if (params.favoriteId) {
        const response = await fetch(`/api/favorites/${params.favoriteId}`, {
          method: 'DELETE',
        })

        if (response.ok) {
          this.favorites = this.favorites.filter(
            (favorite: IFavorite) => favorite.id !== params.favoriteId
          )
        }
      } else if (params.id) {
        const response = await fetch('/api/favorites', {
          method: 'POST',
          body: JSON.stringify({
            agentResourceId: params.id,
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })

        if (response.ok) {
          this.favorites.push(await response.json())
        }
      } else {
        console.log('Invalid Params')
      }
    },
    onSearch: async function () {
      // delay call to server until user stops typing
      clearTimeout(this.onSearchId)
      this.onSearchId = setTimeout(() => {
        this.loadResources()
      }, 500)
    },
    loadResources: async function () {
      this.loading = true
      if (this.searchText) {
        this.agentResources = await (
          await fetch(
            `/api/agentResources/search?searchText=${this.searchText}${
              this.parentId ? `&parentId=${this.parentId}` : ''
            }`
          )
        ).json()
      } else {
        this.agentResources = await (
          await fetch(
            `/api/agentResources${
              this.parentId ? `?parentId=${this.parentId}` : ''
            }`
          )
        ).json()
      }
      this.loading = false
    },
  },
})
